import { render } from "./Subscribe.vue?vue&type=template&id=bba70d58&bindings={\"showSuccess\":\"data\",\"showError\":\"data\",\"showForm\":\"data\",\"location\":\"data\",\"role\":\"data\",\"showFormClass\":\"options\",\"showSuccessClass\":\"options\",\"showErrorClass\":\"options\",\"process\":\"options\",\"showSuccessMessage\":\"options\",\"showErrorMessage\":\"options\"}"
import script from "./Subscribe.vue?vue&type=script&lang=js"
export * from "./Subscribe.vue?vue&type=script&lang=js"

import "./Subscribe.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script